import { Lock } from "lucide-react";
import { requiredTier, UPGRADE_URL } from "@/lib/plan";

export function UpgradeLock({ feature, label, className = "" }) {
  return (
    <a
      href={UPGRADE_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`upgrade-${feature}`}
      title={`Disponible avec le forfait ${requiredTier(feature)}`}
      className={`inline-flex items-center gap-1.5 rounded-xl border border-dashed border-primary/40 bg-primary/5 px-3 py-2 text-xs font-semibold text-primary shrink-0 whitespace-nowrap hover:bg-primary/10 transition-colors ${className}`}
    >
      <Lock className="w-3.5 h-3.5" /> {label} · Forfait {requiredTier(feature)}
    </a>
  );
}
